import { ASSET_TYPES } from "utils/constants";

export function getAssetIcon(type) {
  return ASSET_TYPES[
    Object.keys(ASSET_TYPES).find(
      (key) =>
        ASSET_TYPES[key].type === type || ASSET_TYPES[key].mirror === type
    )
  ].icon;
}
